import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  column-gap: 25px;
  row-gap: 25px;
  grid-template: repeat(10, 1fr) / repeat(10, 1fr);
  grid-template-areas:
    'he he he he he he he he he he'
    'co co co co co co co co co co'
    'co co co co co co co co co co'
    'co co co co co co co co co co'
    'co co co co co co co co co co'
    'co co co co co co co co co co'
    'co co co co co co co co co co';

  height: 720px;
  padding: 50px 30px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  grid-area: he;

  & :last-of-type button {
    border: none;
    align-self: center;
    color: ${({ theme }) => theme.colors.black};
    white-space: nowrap;
  }

  h1 {
    font-weight: 600;
    line-height: 18px;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.graySecondary};
  }

  button {
    padding: 7px 12px;
    font-weight: 500;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.grayAlternative};
    background: transparent;
    border: none;
    border: 2px solid ${({ theme }) => theme.colors.gray1};
    border-radius: 50px;

    &:disabled {
      color: ${({ theme }) => theme.colors.white};
      border: 2px solid ${({ theme }) => theme.colors.primary};
      background-color: ${({ theme }) => theme.colors.primary};
      cursor: default;
    }
  }
`;

export const HeaderItems = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: grab;
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-area: me;

  h3 {
    font-weight: 600;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 40px;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 35px;
    border-radius: 6px;
    background: transparent;
    border: none;
    color: ${({ theme }) => theme.colors.graySecondary};
    font-weight: 600;
    font-size: 14px;

    & + button {
      margin-top: 15px;
    }

    &:disabled {
      color: ${({ theme }) => theme.colors.primary};
      background: #daedf7;
      cursor: default;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: co;

  width: 100%;
`;

export const MinMaxMeasurement = styled.div`
  grid-area: me;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;
